import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ metricsData }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Ensures better control over height
    plugins: {
      legend: {
        position: "top",
        align: "center", // Centers the legend
        display:false
      },
      tooltip: {
        enabled: false, 
        display:false,
        callbacks: {
          label: (context) => `$${context.raw.toLocaleString()}`,
        },
      },
    },
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          display: false, 
        },
        ticks: {
          autoSkip: false, 
        },
        offset: true,
      },
      y: {
        beginAtZero: true,
        border: {
          display: false,
        },
        ticks: {
          callback: (value) => `$${value.toLocaleString()}`,
          maxTicksLimit: 7,
        },
      },
    },
    barThickness: 126,
  };



  const data = {
    labels: ["Trailing 12 Month Value (TTMV)", "Lifetime Value (LTV)"],
    datasets: [
      {
        label: "Revenue",
        data: [metricsData.TTMV , metricsData.LTV],
        backgroundColor: [
          "rgba(30, 144, 254, 1)", "rgba(22, 202, 124, 1)"
        ],
        borderColor: "#ffffff", 
        borderWidth: 0, 
        borderRadius: 8, 
      },
    ],
  };
  

  return (
    <div style={{ height: "500px", display: "flex", alignItems: "center" }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default BarChart;